module.exports = __webpack_public_path__ + "static/img/4.55bf8c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/4.png
// module id = GtfN
// module chunks = 0